import React from "react";
import { useStateContext } from "../../contexts/ContextProvider";

import CakeIcon from "../../assets/images/cake3.svg"

const SendWish = () => {
  const { sendWish } = useStateContext();
  return (
    <>
      <div className={`${sendWish ? "add-event send-wish visible" : "add-event hidden"}`}>
        <div>
          <div className="flex mb-5">
            <div className="left-flex">
              <span>Wish Brooklyn for His/Her special day! </span>
              <span className="icon">
                <img src={CakeIcon} alt="" />
              </span>
            </div>
          </div>
          <div className="wish-form">
            <div className="mb-3">
              <textarea placeholder="Type your message here..."></textarea>
            </div>
          </div>
        </div>

        <div className="event-action">
          <button>Send Wish!</button>
        </div>
      </div>
    </>
  );
};

export default SendWish;
